import { Button, Card, Typography } from "antd";
import {useCallback, useEffect, useMemo, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, Table,TablePagination } from "components/base";
import { CSSProperties } from "styled-components";
import { TableProps } from "antd/lib/table";
import { AppState  } from "store";
import { setRiderTripsSelectedPage, setTripsSelectedPage } from "store/actions";
import { parseTripsTable } from "utils/parsers/trips-parser";
interface ComponentProps {
  onAddIssue: VoidFunction;
}

const { Text } = Typography;

const columns: TableProps<any>["columns"] = [
  { title: "Vehicle ID", dataIndex: "vehicle_id" ,width:150},
  { title: "Trip Start", dataIndex: "start_time",width:190 },
  { title: "Trip End", dataIndex: "end_time", width:190 },
  { title: "Distance (KMs)", dataIndex: "total_km" , width:190 },
  { title: "SoC Used", dataIndex: "soc_used" , align: "left"},
];



export default function TripsTable() {
  const dispatch = useDispatch();
  const {
    riderTrips,
    riderTripsPage,
  } = useSelector<AppState, AppState["trips"]>((state) => state.trips);
  const { selectedPage, totalPages } = riderTripsPage;
   const data = useMemo(
     () => parseTripsTable(riderTrips),
     [riderTrips]
   );
  const onBack = useCallback(() => {
    if (selectedPage > 1) {
      dispatch(setRiderTripsSelectedPage(selectedPage - 1));
    }
  }, [dispatch, selectedPage]);

  const onNext = useCallback(() => {
    if (selectedPage <= totalPages) {
      dispatch(setRiderTripsSelectedPage(selectedPage + 1));
    }
  }, [dispatch, selectedPage, totalPages]);

  const resetCallback = useCallback(() => {
    dispatch(setRiderTripsSelectedPage(1));
  }, [dispatch]);
  return (
    
    <section className="__table-container">
      <Card className="modern-card info-card"
        title={<strong style={{ fontWeight: 700 }}>Trips</strong>}
      bordered={false}
      style={{ marginLeft:4, marginBottom: 36 , marginTop:16, boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
      <Table
        style={
          {
            "--table-height": "330px",
          } as CSSProperties
        }
        customClasses="--custom-height"
        columns={columns}
        dataSource={data}
        pagination={false}
        scroll={{ y: 280 }}
      />

<TablePagination
        page={riderTripsPage}
        onBack={onBack}
        onNext={onNext}
        resetCallback={resetCallback}
      />
      </Card>
    </section>
  );
}
